export default [
  {
    srno: "1",
    title: "ABC",
    likes: "78",
    view: "15k",
    date: "25/05/2021",
    postedBy: "John Doe",
    text: "12"
  },
  {
    srno: "1",
    title: "XYZ",
    likes: "65",
    view: "10k",
    date: "24/05/2021",
    postedBy: "Smith Jos"
  },
  {
    srno: "1",
    title: "PQR",
    likes: "105",
    view: "25k",
    date: "20/05/2021",
    postedBy: "Sumit Jaiswal"
  },
  {
    srno: "1",
    title: "XYW",
    likes: "89",
    view: "18k",
    date: "22/05/2021",
    postedBy: "Darshan Raval"
  }
];
